import DealSpotNGLogo from '../../assets/DealSpotNGLogo';
import './Footer.css';

function Footer() {
  return (
    <div className="footerParentDiv">
      <div className="footerBottom">
        <div className="footerBottomInner">
          <div className="footerLogoContainer">
            <DealSpotNGLogo />
          </div>
          <p className="footerSlogan">Nigeria's smartest marketplace — buy, sell, discover.</p>
          <p className="footerAttribution">
            A product of <a href="https://dabaras.com" target="_blank" rel="noopener noreferrer">Dabara Solutions</a>
          </p>
          <p className="footerCopyright">© {new Date().getFullYear()} DealSpotNG. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
